import {
  createContext,
  useContext,
  useState,
  SetStateAction,
  Dispatch,
  FC,
  ReactNode,
  useEffect,
} from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { useSearchState } from './SearchState'
import { ShopsType } from '@/types/shops'

const ShopContext = createContext<ShopsType>([])

export const useShopState = () => useContext(ShopContext)

const ShopState: FC<{ children: ReactNode }> = ({ children }) => {
  const [shops, setShops] = useState([])
  const { search } = useSearchState()
  const allShopData = useStaticQuery(graphql`
    query {
      allStrapiShops {
        edges {
          node {
            strapiId
            title
            description
            url
            isCertificated
            lat
            lng
            business_hour
            category {
              name
              slug
            }
            category_small {
              name
              slug
            }
            thumbnail {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    formats: [AUTO, WEBP, AVIF]
                    layout: FULL_WIDTH
                    placeholder: BLURRED
                  )
                }
              }
            }
          }
        }
      }
    }
  `).allStrapiShops.edges.map((edge) => edge.node)
  const updateShops = () => {
    setShops(
      allShopData
        .filter((shop) => search.includes(shop.strapiId))
        // 公認店舗を上に持ってくる
        .sort(function (a) {
          return a.isCertificated ? -1 : 1
        }),
    )
  }
  useEffect(() => {
    if (search.length !== 0) {
      updateShops()
    } else {
      setShops([])
    }
  }, [search])

  useEffect(() => {
    setShops(allShopData)
  }, [])

  return <ShopContext.Provider value={shops}>{children}</ShopContext.Provider>
}

export default ShopState
